import { MdEmergencyShare } from 'react-icons/md';
import { Resources } from '../../resource';
import { MainPage } from './main-page';

export const name = Resources.worldCupEmergencyFuse;

export const list = MainPage;

export const icon = MdEmergencyShare;

export const options = { label: 'resource.worldCupEmergencyFuse' };
